import type { App } from 'vue'
import type { Router } from 'vue-router'

// Projects module
const projectsModule = {
  install(app: App) {
    // Register any global components or plugins specific to projects
    console.log('Projects module installed')
  },

  routes(router: Router) {
    // Add all project-specific routes
    const projectRoutes = [
      {
        path: '/projects/:projectId',
        name: 'project-clips',
        component: () => import('./clips/views/clips-listing.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/edit',
        name: 'project-clip-editor',
        component: () => import('./clips/views/clips-view.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/thumbnail',
        name: 'project-clip-thumbnail',
        component: () => import('./clips/title-thumbnail/views/thumbnail-header.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/title-generation',
        name: 'project-clip-title-generation',
        component: () => import('./clips/title-thumbnail/views/title-generation.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/voting',
        name: 'project-clip-voting',
        component: () => import('./clips/voting/views/votes-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/voting/clip-selection',
        name: 'project-clip-voting-selection',
        component: () => import('./clips/voting/views/user-voting-clip-selection-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/voting/title-header',
        name: 'project-clip-voting-title-header',
        component: () => import('./clips/voting/views/user-voting-title-header-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/voting/final-edit',
        name: 'project-clip-voting-final-edit',
        component: () => import('./clips/voting/views/user-voting-final-edit-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      // User voting routes (refactored from votes module)
      {
        path: '/projects/:projectId/clips/:clipId/user-voting/clip-selection',
        name: 'project-clip-user-voting-clip-selection',
        component: () => import('./clips/voting/views/user-voting-clip-selection-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/user-voting/title',
        name: 'project-clip-user-voting-title',
        component: () => import('./clips/voting/views/user-voting-title-header-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/user-voting/header',
        name: 'project-clip-user-voting-header',
        component: () => import('./clips/voting/views/user-voting-title-header-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/polls/thumbnails',
        name: 'project-clip-polls-thumbnails',
        component: () => import('./clips/voting/views/user-voting-title-header-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/polls/titles',
        name: 'project-clip-polls-titles',
        component: () => import('./clips/voting/views/user-voting-title-header-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      {
        path: '/projects/:projectId/clips/:clipId/user-voting/final-edit',
        name: 'project-clip-user-voting-final-edit',
        component: () => import('./clips/voting/views/user-voting-final-edit-view.vue'),
        meta: { useLayout: true, requiresAuth: true },
      },
      // Legacy routes for backward compatibility
      {
        path: '/clips/:projectId',
        name: 'clips-listing',
        redirect: (to: any) => `/projects/${to.params.projectId}`,
      },
      {
        path: '/clips/:projectId/:clipId/edit',
        name: 'clip-editor',
        redirect: (to: any) => `/projects/${to.params.projectId}/clips/${to.params.clipId}/edit`,
      },
      {
        path: '/clips/:projectId/:clipId/title-thumbnail',
        name: 'titles-headers',
        redirect: (to: any) => `/projects/${to.params.projectId}/clips/${to.params.clipId}/title-thumbnail`,
      },
      {
        path: '/clips/:projectId/:clipId/title-generation',
        name: 'title-generation',
        redirect: (to: any) => `/projects/${to.params.projectId}/clips/${to.params.clipId}/title-generation`,
      },
      // Legacy votes module routes for backward compatibility
      {
        path: '/votes/:projectId/:clipId',
        name: 'votes',
        redirect: (to: any) => `/projects/${to.params.projectId}/clips/${to.params.clipId}/voting`,
      },
      {
        path: '/user-voting/clip-selection/:projectId/:clipId',
        name: 'user-voting-clip-selection',
        redirect: (to: any) => `/projects/${to.params.projectId}/clips/${to.params.clipId}/user-voting/clip-selection`,
      },
      {
        path: '/user-voting/title/:projectId/:clipId',
        name: 'user-voting-title',
        redirect: (to: any) => `/projects/${to.params.projectId}/clips/${to.params.clipId}/user-voting/title`,
      },
      {
        path: '/user-voting/header/:projectId/:clipId',
        name: 'user-voting-header',
        redirect: (to: any) => `/projects/${to.params.projectId}/clips/${to.params.clipId}/user-voting/header`,
      },
      {
        path: '/user-voting/final-edit/:projectId/:clipId',
        name: 'user-voting-final-edit',
        redirect: (to: any) => `/projects/${to.params.projectId}/clips/${to.params.clipId}/user-voting/final-edit`,
      },
    ]

    // Add routes to router
    projectRoutes.forEach(route => {
      router.addRoute(route)
    })

    console.log('Projects module routes registered')
  }
}

export default projectsModule
